import { useSelector } from 'react-redux';

import { getCoreRentalIsEligibleForExtension, getCoreRentalMission } from '../selectors/coreApi';

import { MISSION_STATUS } from '../enums';
import { isCoveredForRentalExtension } from '../utils/coreApi';

export const ONE_DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;

export function useRentalExtensionAvailable() {
  const rentalMission = useSelector(getCoreRentalMission);
  const isEligibleForExtension = useSelector(getCoreRentalIsEligibleForExtension);
  const selectedIsCoveredForExtension = useSelector(isCoveredForRentalExtension);

  const isStarted = rentalMission?.status === MISSION_STATUS.STARTED;

  const isAcceptedAndOld =
    rentalMission?.status === MISSION_STATUS.ACCEPTED &&
    rentalMission.requestAcceptedTimestamp != null &&
    Date.now() - Date.parse(rentalMission.requestAcceptedTimestamp) > ONE_DAY_IN_MILLISECONDS;

  return isEligibleForExtension !== false && selectedIsCoveredForExtension && (isStarted || isAcceptedAndOld);
}
